import { actionCreator } from '../../../../utils/actions';

export const editProfileClick = actionCreator('EDIT_PROFILE_CLICK');
export const editPassportClick = actionCreator('EDIT_PASSPORT_CLICK');
export const editAddressClick = actionCreator('EDIT_ADDRESS_CLICK');
export const editPassportAddressClick = actionCreator('EDIT_PASSPORT_ADDRESS_CLICK');



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/ProfileSettings/actions.js